//@ts-check
export const mapByProp = (prop, datas) => {
  return datas.reduce((val, obj) => (val[obj[prop]] = obj, val), {});
};

/**
 * @template K,T
 * @param {T[]} datas 
 * @param {string | string[]} idKey 
 * @return { Normalized<K, T> }
 */
export const normalize = (datas, idKey = 'id') => {
  const getId = data => typeof idKey === 'string' ? data[idKey] : idKey.map(key => data[key]).join('+');
  const init = { byId: {}, allIds: [] };
  if (!datas) {
    // @ts-ignore
    return init;
  }
  //@ts-ignore
  return datas.reduce((entity, data) => {
    const id = getId(data);
    if (data == null) {
      return entity;
    }
    entity.byId[id] = data;
    entity.allIds.push(id);
    return entity;
  }, init);
};
//hdState
export const normalize2 = (datas, idKey = 'id') => {
  // @ts-ignore
  const getId = data => typeof idKey === 'string' ? data[idKey] : idKey.map(key => data[key]).join('+');
  const init = { byId: {}, allIds: [], datas: [] };
  if (!datas) {
    // @ts-ignore
    return init;
  }
  //@ts-ignore
  return datas.reduce((entity, data) => {
    const id = getId(data);
    if (data == null) {
      return entity;
    }
    entity.byId[id] = data;
    entity.allIds.push(id);
    entity.datas.push(data);
    return entity;
  }, init);
};

export const deepEqual = (a, b) => {
  if (a === b) return true;

  if (a && b && typeof a == 'object' && typeof b == 'object') {
    if (a.constructor !== b.constructor) return false;

    let length, i, keys;
    if (Array.isArray(a)) {
      length = a.length;
      if (length != b.length) return false;
      for (i = length; i-- !== 0;)
        if (!deepEqual(a[i], b[i])) return false;
      return true;
    }

    if (a.constructor === RegExp) return a.source === b.source && a.flags === b.flags;
    if (a.valueOf !== Object.prototype.valueOf) return a.valueOf() === b.valueOf();
    if (a.toString !== Object.prototype.toString) return a.toString() === b.toString();

    keys = Object.keys(a);
    length = keys.length;
    if (length !== Object.keys(b).length) return false;

    for (i = length; i-- !== 0;)
      if (!Object.prototype.hasOwnProperty.call(b, keys[i])) return false;

    for (i = length; i-- !== 0;) {
      let key = keys[i];

      if (!deepEqual(a[key], b[key])) return false;
    }

    return true;
  }

  return a !== a && b !== b;
};

const hasOwn = Object.prototype.hasOwnProperty;

const is = (x, y) => {
  if (x === y) {
    return x !== 0 || y !== 0 || 1 / x === 1 / y;
  } else {
    return x !== x && y !== y;
  }
};

export const shallowEqual = (objectA, objectB, options) => {
  if (objectA === objectB) {
    return true;
  }
  if (typeof objectA !== 'object' || objectA === null) {
    return false;
  }
  if (typeof objectB !== 'object' || objectB === null) {
    return false;
  }

  const keysA = Object.keys(objectA);
  const keysB = Object.keys(objectB);

  if (keysA.length !== keysB.length) {
    return false;
  }

  const isEqual = options && typeof options.customEqual === 'function' ? options.customEqual : is;

  for (let i = 0; i < keysA.length; i++) {
    const key = keysA[i];
    if (!hasOwn.call(objectB, key) || !isEqual(objectA[key], objectB[key])) {
      return false;
    }
  }

  return true;
};

export const isEmptyObject = obj => Object.keys(obj).length === 0;

export const arraysEqual = (a, b) => {
  if (a === b) return true;
  if (a == null || b == null) return false;
  if (a.length != b.length) return false;
  for (let i = 0; i < a.length; ++i) {
    if (a[i] !== b[i]) return false;
  }
  return true;
};

export const isEmptyObj = obj => {
  if (obj == null) {
    return true;
  }

  if (typeof obj !== 'object') {
    return false;
  }
  return Object.keys(obj).length === 0;
};

/**
 * data のキーをすべてチェックして、org と違う、または org に入っていない場合、diff に入れる。
 * org に入っている key が data に無くても diff には入らない。
 * @param {*} org 
 * @param {*} data 
 * @returns 
 */
export const getDiff = (org, data) => {
  const diff = {};
  for (const key in data) {
    if (data.hasOwnProperty(key)) {
      const val = data[key];
      const orgVal = org[key];
      if (val === orgVal || (isEmptyObj(val) && isEmptyObj(orgVal))) {
        continue;
      }

      if (Array.isArray(val) && arraysEqual(orgVal, val)) {
        continue;
      }

      diff[key] = val;
    }
  }
  return diff;
};


const valToUndefined = val => (data, dataOrg) => data == val && dataOrg == null ? undefined : data;
export const zeroToUndefined = valToUndefined(0);
export const minusToUndefined = valToUndefined(-1);
export const stringToUndefined = valToUndefined('');

export const deepClone = (source) => {
  if (typeof source !== 'object' || !source)
    return source;
  if (source instanceof Date) {
    throw 'Only Objects or Arrays are supported.';
  }
  const target = source instanceof Array ? [] : {};
  for (let prop in source) {
    if (source instanceof Object && !(source instanceof Array) && !(source.hasOwnProperty(prop))) {
      continue;
    }
    if (source[prop] instanceof Object && !(source[prop] instanceof Date) && !(source[prop] instanceof String)) {
      target[prop] = deepClone(source[prop]);
    } else {
      target[prop] = source[prop];
    }
  }
  return target;
};

/**
 * @template {object} T
 * @param {T} obj 
 * @returns {T} obj
 */
export const deepFreeze = (obj) => {

  if (typeof obj !== 'object' || obj === null)
    return obj;

  Object.freeze(obj);

  for (const prop in obj) {
    if (obj.hasOwnProperty(prop) 
      && obj[prop] != null 
      && (typeof obj[prop] === 'object' || Array.isArray(obj[prop]))
    ) {
      deepFreeze(obj[prop]);
    }
  }

  return obj;
};

/**
 * @template T
 * @param {T} obj 
 * @returns {T}
 */
export const shallowCopy = (obj) => {
  if (typeof obj !== 'object' || obj === null) {
    return obj; 
  }
  if (Array.isArray(obj)) {
    // @ts-ignore
    return [...obj];
  }
  return { ...obj };
};

/**
 * 
 * @param {object} obj 
 * @param {string[]} keysArray 
 * @param {any} newValue 
 * @param {boolean} ignoreNull
 * @returns 
 */
export const updateObject = (obj, keysArray, newValue, ignoreNull = false) => {
  let currentObj = obj;

  for (let i = 0; i < keysArray.length; i++) {
    const key = keysArray[i];

    if (ignoreNull && currentObj == null) {
      return obj;
    }

    if (i === keysArray.length - 1) {
      currentObj[key] = newValue;
    } else {
      currentObj = currentObj[key];
    }
  }

  return obj;
};


/**
 * 
 * @param {object} obj
 * @param {string[]} keysArray 
 * @param {any} newValue 
 * @param {boolean} copy
 * @param {boolean} ignoreNull
 * @param {boolean} fillNull - Prioritizes ignoreNull.
 * @returns 
 */
export const replaceObject = (obj, keysArray, newValue, copy = true, ignoreNull = false, fillNull = false) => {
  const rootObj = copy ? shallowCopy(obj) : obj; // copy the root object
  let currentObj = rootObj; // this one is always copied but not the original object

  for (let i = 0; i < keysArray.length; i++) {
    const key = keysArray[i];

    if (ignoreNull && currentObj == null) {
      return rootObj;
    }

    if (i === keysArray.length - 1) { // replace the value
      currentObj[key] = newValue;
    } else { // replace currentObj to shallowCopy(currentObj[key])
      const currentObjTmp = (currentObj[key] == null && fillNull)
        ? {}
        : (copy ? shallowCopy(currentObj[key]) : currentObj[key]);
      currentObj[key] = currentObjTmp;
      currentObj = currentObjTmp;

    }
  }

  return rootObj;
};

/**
 * 
 * @param {object} obj 
 * @param {string[]} keysArray
 * @param {boolean} ignoreNull
 * @returns 
 */
export const retrieveObject = (obj, keysArray, ignoreNull = false) => {
  let currentObj = obj;

  for (let i = 0; i < keysArray.length; i++) {
    const key = keysArray[i];

    if (ignoreNull && currentObj == null) {
      return currentObj;
    }

    if (i === keysArray.length - 1) {
      return currentObj[key];
    } else {
      currentObj = currentObj[key];
    }
  }

  return undefined;
};

/**
 * 
 * @param {string | string[]} expr 
 */
export const parseMemberExpression = (expr) => {
  if (Array.isArray(expr))
    return expr;
  return String(expr).split('.');
};

export const booleanProp = (val) => {
  if (val == undefined)
    return false;
  if (typeof val === 'boolean')
    return val;
  return true;
};

// arrays

export const tryParseCommaSeparatedArray = (x, stringSeparator) => {
  x = String(x);
  stringSeparator = String(stringSeparator ?? ',') || ',';
  return x.split(stringSeparator).filter(y => !!y);
};

/**
 * This function parses the input `x` by the following:
 * - If `x` is a `string`, it tries to parse it as a JSON object with `JSON.parse`, and replaces `x` with the parsing result.
 * - If `x` is an `Array`, return itself.
 * - If `x` is nullish, return `[]`.
 * - If `x` is a string, call `tryParseCommaSeparatedArray(x, stringSeparator)`.
 * - Return `[x]`.
 * @param {*} x 
 * @param {string | undefined} [stringSeparator] 
 * @returns {Array} The parsing result, guaranteed to be an array.
 */
export const tryParseArray = (x, stringSeparator) => {
  try {
    if (typeof x === 'string' || x instanceof String)
      // @ts-ignore
      x = JSON.parse(x);
  } catch {
    // do nothing
  }
  if (x instanceof Array)
    return x;
  if (x == null)
    return [];
  if (typeof x === 'object')
    return Object.entries(x);
  if (typeof x === 'string')
    return tryParseCommaSeparatedArray(x, stringSeparator) ?? x;
  return [x];
};

export const tryParseJson = (x, _default) => {
  if (!x)
    return _default;
  try {
    return JSON.parse(String(x));
  } catch {
    return _default;
  }
};

/**
 * Get an array with an item inserted at a specified index.
 *
 * @template T
 * @param {T[]} arr - The input array.
 * @param {T} obj - The object to insert.
 * @param {number} [index] - The index at which to insert the object.
 * @returns {T[]} The modified array with the object inserted.
 */
export const getInsertedArray = (arr, obj, index) => {
  if (index === undefined || index >= arr.length)
    return [...arr, obj];
  if (index <= 0)
    return [obj, ...arr];
  return [...arr.slice(0, index), obj, ...arr.slice(index)];
};

/**
 * Get an array with an item replaced at a specified index.
 *
 * @template T
 * @param {T[]} arr - The input array.
 * @param {T} obj - The object to replace at the specified index.
 * @param {number} index - The index at which to replace the object.
 * @returns {T[]} The modified array with the object replaced.
 */
export const getChangedArray = (arr, obj, index) => {
  if (index < 0 || index >= arr.length)
    return [...arr];
  return [...arr.slice(0, index), obj, ...arr.slice(index + 1)];
};

/**
 * Get an array with an item deleted at a specified index.
 *
 * @template T
 * @param {T[]} arr - The input array.
 * @param {number} index - The index at which to delete the object.
 * @returns {T[]} The modified array with the object deleted.
 */
export const getDeletedArray = (arr, index) => {
  if (index < 0 || index >= arr.length)
    return [...arr];
  return [...arr.slice(0, index), ...arr.slice(index + 1)];
};

/**
 * Get an array with an item dragged from one position to another.
 *
 * @template T
 * @param {T[]} arr - The input array.
 * @param {number} startIndex - The index of the item to drag.
 * @param {number} endIndex - The index where the item should be dropped.
 * @returns {T[]} The modified array with the item dragged to the new position.
 */
export const getDraggedArray = (arr, startIndex, endIndex) => {
  const newArr = [...arr];
  const elem = newArr[startIndex];
  newArr.splice(startIndex, 1);
  newArr.splice(endIndex, 0, elem);
  return newArr;
};


/**
 * Drag an item dragged from one position to another.
 *
 * @template T
 * @param {T[]} arr - The input array.
 * @param {number} startIndex - The index of the item to drag.
 * @param {number} endIndex - The index where the item should be dropped.
 * @returns {T[]} The modified array itself.
 */
export const drag = (arr, startIndex, endIndex) => {
  const elem = arr[startIndex];
  arr.splice(startIndex, 1);
  arr.splice(endIndex, 0, elem);
  return arr;
};



/**
 * @template T
 * @param {T[]} arr 
 * @param {(t: T, i: number, arr: T[]) => boolean} filter 
 * @param {T} def 
 */
export const filterFirst = (arr, filter, def = undefined) => {
  const candidates = arr.filter(filter);
  return candidates[0] ?? def;
};